export const initialErrors = {
  titleMain: String() || null,
  titleEn: String() || null,
  sortOrder: String() || null,
};

export const initialGovernorate = {
  titleMain: String(),
  titleEn: String(),
  sortOrder: 0,
  isoCode: String(),
  code: String(),
  latitude: '',
  longitude: '',
  ochaCode: String(),
  postalPrefix: String(),
  region: String(),
};

export type initialGovernorateType = typeof initialGovernorate;
export type initialErrorsType = typeof initialErrors;

export const ALLOWED_GOVERNORATE_REGIONS = [
  'SOUTH',
  'NORTH',
  'CENTRAL_SOUTH',
  'NORTH_CENTRAL',
  'BAGHDAD',
] as const;

export const GOVERNORATE_REGION_OPTIONS = [
  { value: '', labelKey: 'All' },
  { value: 'SOUTH', labelKey: 'South' },
  { value: 'NORTH', labelKey: 'North' },
  { value: 'CENTRAL_SOUTH', labelKey: 'Central South' },
  { value: 'NORTH_CENTRAL', labelKey: 'North Central' },
  { value: 'BAGHDAD', labelKey: 'Baghdad' },
] as const;

export const GOVERNORATE_STATUS_OPTIONS = [
  { value: '', labelKey: 'All' },
  { value: 'true', labelKey: 'Active' },
  { value: 'false', labelKey: 'Inactive' },
] as const;

export const governoratesTableHead = [
  {
    id: 'title',
    numeric: true,
    label: 'Title',
  },
  {
    id: 'isoCode',
    numeric: true,
    label: 'ISO Code',
  },
  {
    id: 'ochaCode',
    numeric: true,
    label: 'OCHA Code',
  },
  {
    id: 'region',
    numeric: true,
    label: 'Region',
  },
  {
    id: 'isActive',
    numeric: true,
    label: 'Status',
  },
  {
    id: '',
    numeric: false,
    label: '',
  },
];

